<template>
  <div>
    Example Excel
    <button @click="download">
      download
    </button>
  </div>
</template>

<script>

export default {
  mounted () {

  },
  methods: {
    async download () {
      const columns = ['ID', 'AMERICAN BULLY CAMELEON', 'NOMBRE', 'AMERICAN BULLY CAMELEON']
      const rows = [
        [1, 'Emy 1', 'Soto 1', 'aGUA'],
        [2, 'Emy 2', 'Soto 2', 'aGUA'],
        [3, 'Emy 3', 'Soto 3', 'aGUA'],
        [4, 'Emy 4', 'Soto 4', 'aGUA']
      ]

      await this.$excelPlugin.downloadFile(columns, rows, 'Emy', 'Emy.xlsx', null, (row) => {
        const cell = row.getCell(1)
        let color = 'FF99FF99'
        if (cell.value > 2) {
          color = 'FF9999'
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        }
      })
    }
  }
}
</script>
